// extracted by mini-css-extract-plugin
module.exports = {"lazyWrapper":"lazy-image-module--lazyWrapper--1wGD_","lazy":"lazy-image-module--lazy--17LE0","lazyLoaded":"lazy-image-module--lazyLoaded--3PLx2"};